import React, { useState } from "react";
import { CsplTable as Table } from "..";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const tableColumns = [
  {
    label: "Source",
    className: "column-vesting-source",
    columnName: "source",
  },
  {
    label: "Years of Service",
    className: "column-vesting-yearsofservice",
    columnName: "yearsOfService",
  },
  {
    label: "Current Vesting %",
    className: "column-vesting-currentvesting",
    columnName: "currentVesting",
  },
  {
    label: "Remarks",
    className: "column-vesting-remarks",
    columnName: "remarks",
  },
];

const VestingRowGroup = ({ employee, index, data = [] }) => {
  const [showAccordion, setShowAccordion] = useState(false);
  const className = showAccordion ? "open" : "";
  const sourceData = [employee];

  return (
    <>
      <Table.Tr>
        <Table.Td className={`column-vesting-icon ${className}`}>
          <FontAwesomeIcon
            onClick={() => setShowAccordion(!showAccordion)}
            icon={!showAccordion ? faChevronRight : faChevronDown}
          />
        </Table.Td>
        <Table.Td className="column-vesting-employeeName">
          {employee.employeeName}
        </Table.Td>
        <Table.Td className="column-vesting-employeeId">
          {employee.employeeId}
        </Table.Td>
        <Table.Td className="column-vesting-socialSecurityNumber">
          {employee.uniquePersonalIdentification}
        </Table.Td>
      </Table.Tr>
      {showAccordion && (
        <>
          <Table.Thead>
            <Table.Tr className="d-flex justify-content-around">
              {tableColumns.map((item, index) => {
                return (
                  <Table.Th key={index} className={item.className}>
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody className="d-flex justify-content-around vesting-detail">
            {sourceData?.map((data, index) => {
              return (
                <Table.Tr
                  key={index}
                  className={"d-flex justify-content-space-between m-1"}
                  style={{ backgroundColor: "white", width: "99%" }}
                >
                  <>
                    <Table.Td key={index} className="w-25">
                      {data.sourceName}
                    </Table.Td>
                    <Table.Td key={index} className="w-25">
                      {data.yearsOfService}
                    </Table.Td>
                    <Table.Td key={index} className="w-25">
                      {data.vestingPercentage}
                    </Table.Td>
                    <Table.Td key={index} className="w-25">
                      {data.comments}
                    </Table.Td>
                  </>
                </Table.Tr>
              );
            })}
          </Table.Tbody>
        </>
      )}
    </>
  );
};
export default VestingRowGroup;
